import Behaviour from '@/core';
import resizer from 'spon-resize';
// import { BADFAMILY } from 'dns'

export default class Submenu extends Behaviour {
	constructor(el) {
		super(el);

		const viewport = resizer();
		const $menuItems = [...el.querySelectorAll('[data-menu-item]')];
		const $subMenuBtn = el.querySelector('[data-open-accordion]');

		let open = false;

		const openSubmenu = e => {
			e.preventDefault();
			if (!open) {
				$subMenuBtn.classList.add('is-submenu-open');
				open = true;
			} else {
				$subMenuBtn.classList.remove('is-submenu-open');
				open = false;
			}
		};

		// const setParentHeight = el => {
		// 	const $subMenu = el.querySelector('[data-submenu]')

		// 	if ($subMenu !== null) {
		// 		if (open === false) {
		// 			el.classList.add('is-submenu-open')
		// 			$subMenu.classList.add('is-visible')
		// 		}
		// 		open = true
		// 	}
		// }

		// const removeParentHeight = el => {
		// 	const $subMenu = el.querySelector('[data-submenu]')

		// 	if ($subMenu !== null && el.classList.length > 0) {
		// 		el.classList.remove('is-submenu-open')
		// 		$subMenu.classList.remove('is-visible')
		// 	}
		// }

		viewport.start();
		viewport.at('(min-width: 66.67em)', {
			match: () => {
				// $menuItems.forEach(el => {
				// 	setParentHeight(el)
				// })
			},

			unmatch: () => {
				$menuItems.forEach(() => {
					// removeParentHeight(el)
					$subMenuBtn.addEventListener('click', openSubmenu);
				});
			},
		});
	}
}


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
